import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import 'tom-select/dist/css/tom-select.css'
import '../stylesheets/tom-select.scss'

// CC-Empfänger-Auswahl: dynamische Remote-Suche über den search_controller
// (model=cc_recipients: interne Disponenten + Kontakte), statt ~1800 Adressen vorzuladen.
// Wert = E-Mail. Freitext bleibt möglich (create), auch beim direkten Absenden (createOnBlur).
export default class extends Controller {
  static targets = ["input"]

  connect() {
    if (!this.hasInputTarget) return
    if (this.inputTarget.tomselect) return

    this.ts = new TomSelect(this.inputTarget, {
      valueField: 'value',
      labelField: 'text',
      searchField: [],          // Suche läuft serverseitig
      create: true,             // freie E-Mail-Eingabe erlauben
      createOnBlur: true,       // getippte E-Mail beim Verlassen übernehmen (kein Verlust beim „Senden")
      // NUR echte E-Mail-Adressen als Freitext anlegen — sonst würde ein bloßes Suchwort
      // (z.B. „Pia") trotz Auswahl eines Treffers zusätzlich als CC hinzugefügt.
      createFilter: (input) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((input || '').trim()),
      persist: false,
      maxOptions: 50,
      loadThrottle: 250,
      placeholder: this.inputTarget.dataset.placeholder || 'Name oder E-Mail suchen …',
      render: {
        option: (data, escape) => {
          const sub = data.subtext
            ? ` <span class="text-xs text-gray-400">(${escape(data.subtext)})</span>` : ''
          return `<div class="py-1">${escape(data.text || data.value)}${sub}</div>`
        },
        item: (data, escape) => `<div>${escape(data.value)}</div>`,
        option_create: (data, escape) =>
          `<div class="create">„${escape(data.input)}" hinzufügen …</div>`,
        no_results: (data, escape) =>
          `<div class="no-results">Keine Treffer für „${escape(data.input)}" – als E-Mail eingeben und Enter</div>`
      },
      load: (query, callback) => {
        if (!query.length) return callback()
        fetch(`/de/backend/search?model=cc_recipients&term=${encodeURIComponent(query)}`,
              { headers: { 'Accept': 'application/json' } })
          .then(res => res.json())
          .then(json => callback(Array.isArray(json) ? json : []))
          .catch(() => callback())
      }
    })
  }

  disconnect() {
    if (this.ts) { this.ts.destroy(); this.ts = null }
  }
}
